import { PageViewPayload, generateActionPayload, upsertPageViewPayload } from './transform';
import { queueCustomEvent } from './queuing-system';
import { SyiTrackingActions } from '../../types/syi';

declare global {
    interface Window {
        clientData?: any;
        Gum?: any;
        permutive?: {
            track: (name: 'Action', payload: any, options: {}) => {};
            addon: (name: 'web', payload: any) => {};
        };
    }
}

export function trackImmediately(window: Window, payload: object): Promise<void> {
    return new Promise((resolve) => {
        try {
            window.permutive?.track('Action', payload, {
                error(errors) {
                    console.error(`PERMUTIVE: ${errors}`);
                },
            });
        } catch (error) {
            console.error(`PERMUTIVE: ${error}`);
        } finally {
            resolve();
        }
    });
}

export const PermutiveEventNames = {
    DOB_NAME: 'DOB name',
    SRP_SAVE_SEARCH_OPEN: 'SRP-savesearch-open',
    WATCHLIST_ADD_ATTEMPT: 'WatchlistAddAttempt',
    R2S_EMAIL_BEGIN: 'R2SEmailBegin',
    R2S_PHONE_BEGIN: 'R2SPhoneBegin',
    R2S_SMS_BEGIN: 'R2SSMSBegin',
    R2S_PHONE_REVEAL_SUCCESS: 'R2SPhoneRevealSuccess',
    ...SyiTrackingActions,
} as const;

export function trackPermutiveCustomEvent(
    window: Window,
    eventName: typeof PermutiveEventNames[keyof typeof PermutiveEventNames],
    additional: Partial<PageViewPayload>,
    isQueueEvent = false
) {
    if (!window.permutive) {
        return;
    }

    const userLoggedIn = window?.clientData?.userData
        ? window?.clientData?.userData.userLoggedIn
        : window?.clientData?.userData;

    const deviceSize = window?.clientData?.baseConfig?.device?.type;

    const payload = generateActionPayload({
        dataLayerBase: window.dataLayer[0],
        additional: upsertPageViewPayload(additional, {
            deviceSize,
            user: { loggedIn: Boolean(userLoggedIn) },
        }),
        actionName: eventName,
    });

    if (isQueueEvent) {
        queueCustomEvent(window, payload);
    } else {
        trackImmediately(window, payload);
    }
}
